<template>
  <div id="contenedor-listado-desktop-pagos">
    <v-alert v-if="listado.length === 0" type="info">
      No se han registrado pagos.
    </v-alert>
    <v-simple-table v-else>
      <template
        v-slot:default>
        <thead>
          <tr>
            <th
              class="text-center">
              <v-icon
                small
                left>
                mdi-calendar
              </v-icon>
              Fecha
            </th>
            <th>
              Contratista
            </th>
            <th>
              Referencia
            </th>
            <th class="text-center">#</th>
            <th>Tipo</th>
            <th>Núm Contrato</th>
            <th>Núm Fact.</th>
            <th class="text-center">Fecha Fact.</th>
            <th class="text-center">
              Núm. Est.
            </th>
            <th class="text-right">
              Total
            </th>
            <th>Fecha Reg</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="(pago) in listado">
            <template>
              <tr
                :key="pago.id">
                <td
                  class="text-center">
                  {{ new Date(`${pago.fecha} 00:00:0`).toLocaleDateString() }}
                </td>
                <td class="font-weight-bold">
                  {{ pago.contratista.nombreRazonSocial }}
                </td>
                <td>
                  {{ pago.referencia }}
                </td>
                <td colspan="6"></td>
                <td
                class="text-right">
                  <v-chip
                    color="primary"
                    dark
                    small>
                    {{ pago.importe | currency }}
                  </v-chip>
                </td>
                <td>
                  {{ new Date(pago.createdAt).toLocaleDateString() }}
                </td>
                <td>
                  <v-btn
                    v-if="pago.detalles.length > 0"
                    disabled
                    icon>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-tooltip
                  v-else
                  top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="borrarPago(pago)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Borrar Pago</span>
                  </v-tooltip>
                </td>
              </tr>
              <template
                v-for="(detalle, index) in pago.detalles">
                <template>
                  <tr
                    :key="detalle.id">
                    <td colspan="3"></td>
                    <td
                      class="text-center">
                      <v-avatar
                        color="secondary"
                        size="26">
                        <span
                          class="white--text">
                          {{ (index + 1) }}
                        </span>
                      </v-avatar>
                    </td>
                    <td>
                      <v-chip
                        :color="detalle.color"
                        dark
                        small>
                        {{ detalle.tipo }}
                      </v-chip>
                    </td>
                    <td>
                      {{ detalle.contrato.numero }}
                    </td>
                    <td>
                      {{ detalle.pagoSolicitudDetalle.numeroFactura }}
                    </td>
                    <td
                      class="text-center">
                      {{ new Date(`${detalle.pagoSolicitudDetalle.fechaFactura} 00:00:0`)
                      .toLocaleDateString() }}
                    </td>
                    <td
                      class="text-center">
                      <template
                        v-if="detalle.pagoSolicitudDetalle.estimacion">
                        {{ detalle.pagoSolicitudDetalle.estimacion.numero }}
                      </template>
                    </td>
                    <td class="text-right">
                      <v-chip
                        color="grey lighten-4"
                        small>
                        {{ detalle.pagoSolicitudDetalle.importe | currency }}
                      </v-chip>
                    </td>
                    <td></td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on" @click="borrarDetallePago(detalle)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Borrar Detalle</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
// import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoDesktopPagos',
  components: {
  },
  props: {
    listado: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    borrarPago(pago) {
      eventBus.$emit('borrar-pago', pago);
    },
    borrarDetallePago(detalle) {
      eventBus.$emit('borrar-detalle-pago', detalle);
    },
  },
};
</script>

<style lang="scss">

</style>
